var exports = {
  "W3": "ComposerSurface__ZC8B2c",
  "S4": "QueuedMessagesRegion__E48_na",
  "EX": "QueuedMessagesWarning__JtMJio",
  "fY": "ComposerRegion___WHz1I",
};

module.exports = exports;
